<template>
  <div>
    <div v-if="hasPopularList">
      <nav class="search-popular-nav">
        <h3 class="a11y-hidden">서브 메뉴 네비게이션</h3>
        <ul class="sub-list">
          <li>
            <button type="button" @click="selectedTab('program')" :class="tabActiveClass('program')">인기 시리즈</button>
          </li>
          <li>
            <button type="button" @click="selectedTab('movie')" :class="tabActiveClass('movie')">인기 영화</button>
          </li>
        </ul>
      </nav>
      <div class="search-popular-list-wrap">
        <ul class="search-popular-list">
          <li v-for="(cell, index) in cellList" :key="`${contentType}_${index}`">
            <a href="#" @click.prevent="goDetail(cell, index)" :aria-label="altText(cell)">
              <div class="inner-wrap" aria-hidden="true">
                <div class="picture-area">
                  <picture>
                    <img :src="getCellImage(cell)" @load="onImageLoad" :alt="altText(cell)" lazy="loaded">
                  </picture>
                  <div :class="altClassName(cell)">
                    <span>{{alt(cell)}}</span>
                  </div>
                </div>
                <div class="cell-info">
                  <div class="cell-title-wrap" v-title-list="{'titleList': cell.title_list}"></div>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div v-else class="search-loading">
      <EmptyIcon />
      <span>잠시 후 시도해주세요</span>
    </div>
  </div>
</template>
<script>
import { SearchService } from '@/common/api/api.service'
import { titleList } from '@/common/directives'
import { get } from 'lodash'
import { getEventListByType } from '@/common/util/event.util'
import { EventBus } from '@/components/eventbus/EventBus'
import { ON_CLICK } from '@/common/event.const'
import { parseUrl } from 'query-string'
import { PATH_NAME_PLAYER } from '@/common/router.const'
import { resizeThumbnail } from '@/common/image.filter'
import EmptyIcon from '@/assets/svg/common/img_empty.svg'
import { sendEventLogSearchPopularContents } from '@/common/util/log.v2.send'

export default {
  name: 'SearchPopularContentsList',
  components: {
    EmptyIcon
  },
  data () {
    return {
      contentType: 'program',
      cellList: [],
      isImageLoaded: false
    }
  },
  directives: {
    titleList
  },
  computed: {
    hasPopularList () {
      return this.cellList.length > 0
    }
  },
  methods: {
    setData () {
      SearchService.getSearchPopularKeywords({ contentType: this.contentType }).then(({ data }) => {
        this.cellList = get(data, 'cell_toplist.celllist', [])
      })
    },
    altText (cell) {
      return get(cell, 'title_list.0.text', '')
    },
    selectedTab (type) {
      this.contentType = type
    },
    tabActiveClass (type) {
      return this.contentType === type ? 'on' : ''
    },
    getCellImage (cell) {
      return resizeThumbnail(get(cell, 'thumbnail', ''), { width: 312, height: 176, quality: 75, multiply: 3 })
    },
    goDetail (cell, index) {
      const { onNavigationEvent, onClickEvent } = getEventListByType(get(cell, 'event_list', []))
      if (onClickEvent) EventBus.$emit(ON_CLICK, onClickEvent)
      let navigationUrl = get(onNavigationEvent, 'url', '').replace('.html', '')
      let { url, query } = parseUrl(navigationUrl)
      let section = url.split('/').pop()

      sendEventLogSearchPopularContents({ cellInfo: cell, index: index })
      this.$router.push({
        name: PATH_NAME_PLAYER,
        params: {
          section
        },
        query: query
      })
    },
    alt (cell) {
      return get(cell, 'alt', '')
    },
    onImageLoad () {
      this.isImageLoaded = true
    },
    altClassName (cell) {
      let className = 'alt-title'
      if (this.isImageLoaded && get(cell, 'thumbnail', '') !== '') {
        className = `${className} fade-out`
      }
      return className
    }
  },
  created () {
    this.setData()
  },
  watch: {
    contentType () {
      this.cellList = []
      this.setData()
    }
  }
}
</script>
